/**
 * AI 服务配置 API
 */

import { http } from '../request';

export interface AiServiceConfig {
  id: string;
  serviceName: string;
  serviceType: 'LOCAL' | 'CLOUD';
  apiUrl: string;
  apiKey?: string;
  modelName: string;
  timeoutMs?: number;
  isEnabled: boolean;
  isDefault: boolean;
  priority: number;
  remark?: string;
}

/**
 * 获取 AI 服务列表
 */
export function getAiServiceList(): Promise<AiServiceConfig[]> {
  return http.get('/admin/ai-service/list');
}

/**
 * 根据 ID 获取 AI 服务详情
 */
export function getAiServiceById(id: string): Promise<AiServiceConfig> {
  return http.get(`/admin/ai-service/${id}`);
}

/**
 * 创建 AI 服务
 */
export function addAiService(data: AiServiceConfig): Promise<void> {
  return http.post('/admin/ai-service', data);
}

/**
 * 更新 AI 服务
 */
export function updateAiService(data: AiServiceConfig): Promise<void> {
  return http.put('/admin/ai-service', data);
}

/**
 * 删除 AI 服务
 */
export function deleteAiService(id: string): Promise<void> {
  return http.delete(`/admin/ai-service/${id}`);
}

/**
 * 设置默认服务
 */
export function setDefaultService(id: string): Promise<void> {
  return http.put(`/admin/ai-service/${id}/default`);
}

/**
 * 测试连接
 */
export function testConnection(data: AiServiceConfig): Promise<void> {
  return http.post('/admin/ai-service/test', data);
}
